/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".iframe__container[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 5;\n  width: 100%;\n  height: 100%;\n  background: white;\n}\n\niframe[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border: none;\n  overflow: hidden;\n}\n\n.close-button[_ngcontent-%COMP%] {\n  position: absolute;\n  right: 1vw;\n  top: 1vw;\n  z-index: 5;\n}"];
export { styles as styles };
